const TOKEN_KEY = "token";

/** 读取本地存储的访问令牌 */
export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

/** 写入访问令牌 */
export const setToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

/** 清除访问令牌 */
export const clearToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};
